/*global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/home-videos.js'; import './autoload/menu.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';

import ScrollOut from 'scroll-out';
import { gsap } from 'gsap'; // eslint-disable-line
import { ScrollTrigger } from 'gsap/ScrollTrigger'; // eslint-disable-line
/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('.js-home-stories').on(
    'init reInit afterChange',
    function (event, slick, currentSlide) {
      let i = (currentSlide ? currentSlide : 0) + 1;
      let percent = (i / slick.slideCount) * 100;
      $('.slider-progress').css('width', percent + '%');
    }
  );

  $('.js-home-stories').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: $('.arrow-left'),
    nextArrow: $('.arrow-right'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  const baseSliderSettings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Posts slider
  $('.resources-posts-slider').slick({
    ...baseSliderSettings,
    prevArrow: $('.resources-posts-buttons .slider-button-prev'),
    nextArrow: $('.resources-posts-buttons .slider-button-next'),
  });

  // Articles slider
  $('.resources-articles-slider').slick({
    ...baseSliderSettings,
    prevArrow: $('.resources-articles-buttons .slider-button-prev'),
    nextArrow: $('.resources-articles-buttons .slider-button-next'),
  });

  // Blog slider
  $('.resources-blog-slider').slick({
    ...baseSliderSettings,
    prevArrow: $('.resources-blog-buttons .slider-button-prev'),
    nextArrow: $('.resources-blog-buttons .slider-button-next'),
  });

  // Videos slider
  $('.resources-videos-slider').slick({
    ...baseSliderSettings,
    prevArrow: $('.resources-videos-buttons .slider-button-prev'),
    nextArrow: $('.resources-videos-buttons .slider-button-next'),
  });

  /**
   * Blog Posts Slider
   */
  function initBlogSlider() {
    const $slider = $('.blog-posts__slider');

    // if (!$slider.length) return;

    if (window.innerWidth <= 1081) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 782,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  initBlogSlider();
  $(window).on('resize', function () {
    initBlogSlider();
  });

  //Sidebar toggle
  const toggleButton = document.querySelector('.js-legal-services-toggle');

  if (toggleButton) {
    const menuWrapper = toggleButton.nextElementSibling;

    if (menuWrapper && menuWrapper.tagName === 'DIV') {
      menuWrapper.classList.add('js-legal-services-menu');

      toggleButton.addEventListener('click', function () {
        if (window.innerWidth <= 782) return;

        menuWrapper.classList.toggle('is-open');
        toggleButton.classList.toggle('active');
      });
    }
  }

  /**
   * Approach Slider
   */
  $('.contact-section__slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    // rows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 782,
        settings: {
          infinite: false,
          arrows: true,
        },
      },
    ],
  });

  if ($('.contact-section__slide').length) {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.contact-section__slide').forEach((slide) => {
      gsap.from(slide, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: slide,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  }
  /**
   * Testimonials Slider
   */
  $('.case-results-section').each(function () {
    const $wrap = $(this);
    const $slider = $wrap.find('.case-results__slider');
    const $prev = $wrap.find('.case-results-prev');
    const $next = $wrap.find('.case-results-next');

    $slider.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      adaptiveHeight: false,
      prevArrow: $prev,
      nextArrow: $next,

      responsive: [
        {
          breakpoint: 783,
          settings: {
            slidesToShow: 1,
            arrows: true,
          },
        },
      ],
    });
  });
  $('.testimonials').each(function () {
    const $wrap = $(this);

    $wrap.find('.testimonials__slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      rows: false,
      adaptiveHeight: true,
      prevArrow: $wrap.find('.testimonials-prev'),
      nextArrow: $wrap.find('.testimonials-next'),
    });
  });

  // reusable clone function
  function cloneMultiple(node, times, container) {
    for (let i = 0; i < times; i++) {
      container.appendChild(node.cloneNode(true));
    }
  }

  // reusable slider init
  function initSlider({
    containerId,
    trackSelector,
    animationName,
    speed = 20,
    clones = 15,
  }) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const ticker = container.querySelector(trackSelector);
    if (!ticker) return;

    // clone elements
    cloneMultiple(ticker, clones, container);

    // calculate width
    const totalWidth = ticker.offsetWidth;

    // duration based on speed
    const duration = totalWidth / speed;

    // apply animation
    container.style.animation = `${animationName} ${duration}s linear infinite`;

    // create unique keyframes
    const style = document.createElement('style');
    style.textContent = `
    @keyframes ${animationName} {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${totalWidth}px); }
    }
  `;
    document.head.appendChild(style);
  }

  // init both sliders
  initSlider({
    containerId: 'js-contact-line-slider',
    trackSelector: '.contact-line-slider__list-track',
    animationName: 'scrollTickerFooter',
    speed: 20,
  });

  initSlider({
    containerId: 'js-pa-line-slider',
    trackSelector: '.pa-line-slider__list-track',
    animationName: 'scrollTickerPA',
    speed: 20,
  });

  initSlider({
    containerId: 'js-logos-line-slider',
    trackSelector: '.logos-line-slider__list-track',
    animationName: 'scrollTickerLogos',
    speed: 20,
  });

  // /**
  //  * Accordion
  //  */
  // $('.accordion__title').each(function () {
  //   // Initialize aria-expanded based on active class
  //   const $this = $(this);
  //   const $accordionItem = $this.closest('.accordion__item');
  //   const expanded = $accordionItem.hasClass('active') ? 'true' : 'false';
  //   $this.attr('aria-expanded', expanded);
  // });
  //
  // $('.accordion__title').on('click', function () {
  //   const $this = $(this);
  //   const $accordionItem = $this.closest('.accordion__item');
  //   const $accordionContent = $accordionItem.find('.accordion__content');
  //
  //   if ($accordionItem.hasClass('active')) {
  //     $accordionContent.slideUp(400, function () {
  //       $accordionItem.removeClass('active');
  //       $this.attr('aria-expanded', 'false');
  //     });
  //   } else {
  //     // Close other open accordion items
  //     $this
  //       .closest('.accordion')
  //       .find('.accordion__item.active .accordion__content')
  //       .slideUp(400, function () {
  //         const $parentItem = $(this).closest('.accordion__item');
  //         $parentItem.removeClass('active');
  //         $parentItem.find('.accordion__title').attr('aria-expanded', 'false');
  //       });
  //
  //     // Open the clicked accordion item
  //     $accordionContent.slideDown(400, function () {
  //       $accordionItem.addClass('active');
  //       $this.attr('aria-expanded', 'true');
  //     });
  //   }
  // });

  $('.accordion__title').on('click', function () {
    const $this = $(this);
    const $accordionItem = $this.closest('.accordion__item');
    const $accordionContent = $accordionItem.find('.accordion__content');
    const $accordion = $this.closest('.accordion');

    if ($accordionItem.hasClass('active')) {
      // CLOSE CURRENT
      $accordionItem.removeClass('active');
      $this.attr('aria-expanded', 'false');
      $accordionContent.slideUp(400);
    } else {
      // CLOSE OTHER OPEN ITEMS FIRST ✅
      const $openItems = $accordion.find('.accordion__item.active');

      $openItems
        .removeClass('active')
        .find('.accordion__title')
        .attr('aria-expanded', 'false');

      $openItems.find('.accordion__content').slideUp(400);

      // OPEN CLICKED ITEM ✅
      $accordionItem.addClass('active');
      $this.attr('aria-expanded', 'true');
      $accordionContent.slideDown(400);
    }
  });

  // Allow Enter and Space to toggle the accordion when the title (button) is focused

  $(document).on('keydown', '.accordion__title', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.3,
    smooth: true,
  });

  /**
   * Detect element appearance in viewport
   */
  if (window.innerWidth > 768) {
    ScrollOut({
      threshold: 0.2,
      targets: '.footer-logo',
      cssProps: {
        visibleY: true,
      },
    });
    ScrollOut({
      threshold: 0.5,
      once: true,
      onShown: function (element) {
        if ($(element).is('.ease-order')) {
          $(element)
            .find('.ease-order__item')
            .each(function (i) {
              let $this = $(this);
              $(this).attr('data-scroll', '');
              window.setTimeout(function () {
                $this.attr('data-scroll', 'in');
              }, 300 * i);
            });
        }
      },
    });

    if ($('.hero-logo').length) {
      gsap.registerPlugin(ScrollTrigger);
      const logo = document.querySelector('.hero-logo');

      let mouseX = 0;
      let mouseY = 0;
      let cx = 0;
      let cy = 0;

      window.addEventListener('mousemove', (e) => {
        mouseX = e.clientX / window.innerWidth - 0.5;
        mouseY = e.clientY / window.innerHeight - 0.5;
      });

      gsap.ticker.add(() => {
        cx += (mouseX - cx) * 0.1;
        cy += (mouseY - cy) * 0.1;

        gsap.set(logo, {
          xPercent: -50,
          yPercent: -50,
          rotateY: cx * 10,
          rotateX: -cy * 10,
          transformPerspective: 900,
          transformOrigin: 'center center',
        });
      });
    }
  }

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();

  var $aopSlider = $('.aop-image-slider');

  $aopSlider.on('init afterChange', function (event, slick, currentSlide) {
    var index = currentSlide || 0;

    $('.aop-slider-nav li').removeClass('active');
    $('.aop-slider-nav li').eq(index).addClass('active');
  });

  if (!$aopSlider.hasClass('slick-initialized')) {
    $aopSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      fade: false,
      infinite: true,
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '0px',
      focusOnSelect: true,

      responsive: [
        {
          breakpoint: 782,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
      ],
    });
  }

  $('.aop-slider-nav li').on('mouseenter', function () {
    var index = $(this).index();
    $aopSlider.slick('slickGoTo', index);
  });

  let page = 1;
  let maxPages = null;

  $('.load-more-button').on('click', function () {
    page++;

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'load_more_reviews',
        page: page,
      },
      beforeSend: function () {
        $('.load-more-button').text('Loading...');
      },
      success: function (res) {
        if (res.html) {
          $('.testimonials-list').append(res.html);
        }

        maxPages = res.max_pages;

        $('.load-more-button').text('View More');

        // ✅ HIDE BUTTON WHEN NO MORE POSTS
        if (page >= maxPages) {
          $('.load-more-button').hide();
        }
      },
    });
  });
});

/* ---------------------------
 * Blog Filter with Pagination
 *
 * --------------------------- */
jQuery(function ($) {
  let selectedCats = [];
  let selectedVideoCats = [];
  let selectedArticleCats = [];

  const $pickedContainer = $('#pickedCategories');
  const $pickedVideoContainer = $('#pickedVideoCategories');
  const $pickedArticleCategories = $('#pickedArticleCategories');

  /* =========================
     GET FROM URL
  ========================= */
  function getCatsFromURL(param) {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(param);
    return value ? value.split(',') : [];
  }

  /* =========================
     RENDER PICKED TAGS
  ========================= */
  function renderPicked() {
    $pickedContainer.empty();
    $pickedVideoContainer.empty();
    $pickedArticleCategories.empty();

    // BLOG
    selectedCats.forEach((slug) => {
      const $el = $(`.category-checkbox[data-slug="${slug}"]`);
      const name = $el.length ? $el.data('name') : slug;

      $pickedContainer.append(`
        <span class="picked-item" data-slug="${slug}">
          ${name}
          <span class="remove-picked" data-type="blog" data-slug="${slug}">✕</span>
        </span>
      `);
    });

    // VIDEOS
    selectedVideoCats.forEach((slug) => {
      const $el = $(`.video-category-checkbox[data-slug="${slug}"]`);
      const name = $el.length ? $el.data('name') : slug;

      $pickedVideoContainer.append(`
        <span class="picked-item" data-slug="${slug}">
          ${name}
          <span class="remove-picked" data-type="video" data-slug="${slug}">✕</span>
        </span>
      `);
    });

    // ARTICLES
    selectedArticleCats.forEach((slug) => {
      const $el = $(`.article-category-checkbox[data-slug="${slug}"]`);
      const name = $el.length ? $el.data('name') : slug;

      $pickedArticleCategories.append(`
    <span class="picked-item" data-slug="${slug}">
      ${name}
      <span class="remove-picked" data-type="article" data-slug="${slug}">✕</span>
    </span>
  `);
    });
  }

  /* =========================
     SYNC CHECKBOXES
  ========================= */
  function syncBlogCheckboxes() {
    $('.category-checkbox').removeClass('selected');

    selectedCats.forEach((slug) => {
      $(`.category-checkbox[data-slug="${slug}"]`).addClass('selected');
    });
  }

  function syncVideoCheckboxes() {
    $('.video-category-checkbox').removeClass('selected');

    selectedVideoCats.forEach((slug) => {
      $(`.video-category-checkbox[data-slug="${slug}"]`).addClass('selected');
    });
  }

  function syncArticleCheckboxes() {
    $('.article-category-checkbox').removeClass('selected');

    selectedArticleCats.forEach((slug) => {
      $(`.article-category-checkbox[data-slug="${slug}"]`).addClass('selected');
    });
  }

  /* =========================
     CLICK HANDLERS
  ========================= */

  // BLOG click
  $(document).on('click', '.category-checkbox', function () {
    const slug = $(this).data('slug');

    if (selectedCats.includes(slug)) {
      selectedCats = selectedCats.filter((s) => s !== slug);
    } else {
      selectedCats.push(slug);
    }

    syncBlogCheckboxes();
    renderPicked();
  });

  // VIDEO click
  $(document).on('click', '.video-category-checkbox', function () {
    const slug = $(this).data('slug');

    if (selectedVideoCats.includes(slug)) {
      selectedVideoCats = selectedVideoCats.filter((s) => s !== slug);
    } else {
      selectedVideoCats.push(slug);
    }

    syncVideoCheckboxes();
    renderPicked();
  });

  // Article click
  $(document).on('click', '.article-category-checkbox', function () {
    const slug = $(this).data('slug');
    if (selectedArticleCats.includes(slug)) {
      selectedArticleCats = selectedArticleCats.filter((s) => s !== slug);
    } else {
      selectedArticleCats.push(slug);
    }

    syncArticleCheckboxes();
    renderPicked();
  });

  /* =========================
     REMOVE PICKED TAG
  ========================= */
  $(document).on('click', '.remove-picked', function () {
    const slug = $(this).data('slug');
    const type = $(this).data('type');

    if (type === 'blog') {
      selectedCats = selectedCats.filter((s) => s !== slug);
      syncBlogCheckboxes();
    }

    if (type === 'video') {
      selectedVideoCats = selectedVideoCats.filter((s) => s !== slug);
      syncVideoCheckboxes();
    }

    if (type === 'article') {
      selectedArticleCats = selectedArticleCats.filter((s) => s !== slug);
      syncArticleCheckboxes();
    }

    renderPicked();
  });

  /* =========================
     APPLY FILTERS
  ========================= */

  // BLOG
  $('#applyFilterBtn').on('click', function () {
    const params = new URLSearchParams();

    if (selectedCats.length) {
      params.set('category_name', selectedCats.join(','));
    }

    window.location.href = '/blog/?' + params.toString();
  });

  // VIDEOS
  $('#applyVideosFilterBtn').on('click', function () {
    const params = new URLSearchParams();

    if (selectedVideoCats.length) {
      params.set('video_category', selectedVideoCats.join(','));
    }

    window.location.href = '/videos/?' + params.toString();
  });
  // Articles
  $('#applyArticleFilterBtn').on('click', function () {
    const params = new URLSearchParams();

    if (selectedArticleCats.length) {
      params.set('article_category', selectedArticleCats.join(','));
    }

    window.location.href = '/articles/?' + params.toString();
  });

  /* =========================
     RESET
  ========================= */
  $('#resetFilterBtn').on('click', function () {
    window.location.href = '/blog/';
  });

  $('#resetVideosFilterBtn').on('click', function () {
    window.location.href = '/videos/';
  });

  $('#resetArticleFilterBtn').on('click', function () {
    window.location.href = '/articles/';
  });

  /* =========================
     INIT (LOAD FROM URL)
  ========================= */
  selectedCats = getCatsFromURL('category_name');
  selectedVideoCats = getCatsFromURL('video_category');
  selectedArticleCats = getCatsFromURL('article_category');

  syncBlogCheckboxes();
  syncVideoCheckboxes();
  syncArticleCheckboxes();
  renderPicked();
});

// jQuery(function ($) {
//   let selectedCats = [];
//   let selectedVideoCats = [];
//   // const name = $(`.category-checkbox[data-slug="${slug}"]`).data('name');
//
//   const $pickedContainer = $('#pickedCategories');
//   const $pickedVideoContainer = $('#pickedVideoCategories');
//
//   function getCatsFromURL() {
//     const params = new URLSearchParams(window.location.search);
//     const cats = params.get('category_name');
//
//     return cats ? cats.split(',') : [];
//   }
//
//   function renderPicked() {
//     $pickedContainer.empty();
//     $pickedVideoContainer.empty();
//
//     selectedCats.forEach((slug) => {
//       const $el = $(`.category-checkbox[data-slug="${slug}"]`);
//
//       const name = $el.length ? $el.data('name') : slug; // fallback
//
//       $pickedContainer.append(`
//       <span class="picked-item" data-slug="${slug}">
//         ${name}
//         <span class="remove-picked" data-slug="${slug}">✕</span>
//       </span>
//     `);
//     });
//
//     selectedVideoCats.forEach((slug) => {
//       const $el = $(`.category-checkbox[data-slug="${slug}"]`);
//
//       const name = $el.length ? $el.data('name') : slug; // fallback
//
//       $pickedVideoContainer.append(`
//       <span class="picked-item" data-slug="${slug}">
//         ${name}
//         <span class="remove-picked" data-slug="${slug}">✕</span>
//       </span>
//     `);
//     });
//   }
//
//   function syncCheckboxes() {
//     $('.category-checkbox').removeClass('selected');
//
//     selectedCats.forEach((slug) => {
//       $(`.category-checkbox[data-slug="${slug}"]`).addClass('selected');
//     });
//   }
//
//   /* CATEGORY CLICK */
//   $(document).on('click', '.category-checkbox', function () {
//     const slug = $(this).data('slug');
//
//     if (selectedCats.includes(slug)) {
//       selectedCats = selectedCats.filter((s) => s !== slug);
//     } else {
//       selectedCats.push(slug);
//     }
//
//     syncCheckboxes();
//     renderPicked();
//   });
//
//   /* REMOVE PICKED */
//   $(document).on('click', '.remove-picked', function () {
//     const slug = $(this).data('slug');
//
//     selectedCats = selectedCats.filter((s) => s !== slug);
//
//     syncCheckboxes();
//     renderPicked();
//   });
//
//   /* APPLY */
//   $('#applyFilterBtn').on('click', function () {
//     const params = new URLSearchParams();
//
//     if (selectedCats.length) {
//       params.set('category_name', selectedCats.join(','));
//     }
//
//     window.location.href = '/blog/?' + params.toString();
//   });
//
//   $('#applyVideosFilterBtn').on('click', function () {
//     const params = new URLSearchParams();
//
//     if (selectedCats.length) {
//       params.set('category_name', selectedCats.join(','));
//     }
//
//     window.location.href = '/videos/?' + params.toString();
//   });
//
//   /* RESET */
//   $('#resetFilterBtn').on('click', function () {
//     window.location.href = '/blog/';
//   });
//   $('#resetVideosFilterBtn').on('click', function () {
//     window.location.href = '/videos/';
//   });
//
//   /* INIT */
//   selectedCats = getCatsFromURL();
//
//   syncCheckboxes();
//   renderPicked();
// });

//
// jQuery(function ($) {
//   let selectedCats = [];
//   let currentPage = 1;
//
//   const $postsWrapper = $('#blogPostsWrapper');
//   const $pickedContainer = $('#pickedCategories');
//
//   /* ---------------------------
//    * PARSE URL (SAFE)
//    * --------------------------- */
//   function getStateFromURL() {
//     const path = window.location.pathname;
//
//     const pageMatch = path.match(/\/page\/(\d+)\/?$/);
//     // const baseMatch = path.match(/^\/blog\/([^\/]+)?/);
//     const baseMatch = path.match(/^\/blog\/([^/]+)/);
//
//     let cats = [];
//
//     if (baseMatch && baseMatch[1]) {
//       const segment = baseMatch[1];
//
//       // exclude "page"
//       if (segment !== 'page') {
//         cats = segment.split(',').filter(Boolean);
//       }
//     }
//
//     return {
//       page: pageMatch ? parseInt(pageMatch[1]) : 1,
//       cats: cats,
//     };
//   }
//
//   /* ---------------------------
//    * BUILD URL (SINGLE SOURCE OF TRUTH)
//    * --------------------------- */
//   function buildURL() {
//     let url = '/blog/';
//
//     if (selectedCats.length) {
//       url += selectedCats.join(',') + '/';
//     }
//
//     if (currentPage > 1) {
//       url += `page/${currentPage}/`;
//     }
//
//     return url;
//   }
//
//   /* ---------------------------
//    * UPDATE URL
//    * --------------------------- */
//   function updateURL() {
//     const url = buildURL();
//
//     window.history.pushState(
//       {
//         cats: selectedCats,
//         page: currentPage,
//       },
//       '',
//       url
//     );
//   }
//
//   /* ---------------------------
//    * RENDER PICKED CATEGORIES
//    * --------------------------- */
//   function renderPickedCategories() {
//     $pickedContainer.empty();
//
//     selectedCats.forEach((slug) => {
//       const name = $(`.category-checkbox[data-slug="${slug}"]`).data('name');
//
//       if (!name) return;
//
//       $pickedContainer.append(`
//         <span class="picked-item" data-slug="${slug}">
//           ${name}
//           <span class="remove-picked" data-slug="${slug}">✕</span>
//         </span>
//       `);
//     });
//   }
//
//   /* ---------------------------
//    * LOAD POSTS (AJAX)
//    * --------------------------- */
//   function loadPosts(page = 1) {
//     $.ajax({
//       url: ajax_object.ajax_url,
//       type: 'POST',
//       data: {
//         action: 'filter_posts',
//         categories: selectedCats,
//         paged: page,
//         nonce: ajax_object.nonce,
//       },
//       beforeSend: function () {
//         $postsWrapper.addClass('loading');
//       },
//       success: function (response) {
//         $postsWrapper.html(response.posts);
//
//         currentPage = page;
//
//         renderPagination(response.max_pages, currentPage);
//         updateURL();
//
//         $postsWrapper.removeClass('loading');
//
//         if ($.fn.matchHeight) {
//           $('.matchHeight').matchHeight();
//         }
//       },
//     });
//   }
//
//   /* ---------------------------
//    * TOGGLE DROPDOWN
//    * --------------------------- */
$('.open-list').on('click', function () {
  $(this).toggleClass('opened');
  $('.list-dropdown').toggleClass('opened');
});
//
//   /* ---------------------------
//    * CATEGORY CLICK
//    * --------------------------- */
//   $(document).on('click', '.category-checkbox', function () {
//     const slug = $(this).data('slug');
//
//     if (!slug) return;
//
//     if (selectedCats.includes(slug)) {
//       selectedCats = selectedCats.filter((s) => s !== slug);
//       $(this).removeClass('selected');
//     } else {
//       selectedCats.push(slug);
//       $(this).addClass('selected');
//     }
//   });
//
//   /* ---------------------------
//    * APPLY FILTER
//    * --------------------------- */
//   $('#applyFilterBtn').on('click', function () {
//     $('.open-list, .list-dropdown').removeClass('opened');
//
//     currentPage = 1;
//
//     renderPickedCategories();
//     loadPosts(1);
//   });
//
//   /* ---------------------------
//    * REMOVE PICKED CATEGORY
//    * --------------------------- */
//   $(document).on('click', '.remove-picked', function () {
//     const slug = $(this).data('slug');
//
//     selectedCats = selectedCats.filter((s) => s !== slug);
//
//     $(`.category-checkbox[data-slug="${slug}"]`).removeClass('selected');
//
//     renderPickedCategories();
//
//     currentPage = 1;
//     loadPosts(1);
//   });
//
//   /* ---------------------------
//    * RESET FILTERS
//    * --------------------------- */
//   $('#resetFilterBtn').on('click', function () {
//     selectedCats = [];
//
//     $('.category-checkbox').removeClass('selected');
//     $pickedContainer.empty();
//
//     currentPage = 1;
//     loadPosts(1);
//   });
//
//   /* ---------------------------
//    * PAGINATION BUILD
//    * --------------------------- */
//   function renderPagination(maxPages, page) {
//     let html = '<div class="pagination">';
//
//     if (page > 1) {
//       html += `<a href="${buildURL(page - 1)}" class="page-link prev">«</a>`;
//     } else {
//       html += `<span class="page-link prev disabled">«</span>`;
//     }
//
//     for (let i = 1; i <= maxPages; i++) {
//       const active = i === page ? 'active' : '';
//       html += `<a href="${buildURL(i)}" class="page-link ${active}">${i}</a>`;
//     }
//
//     if (page < maxPages) {
//       html += `<a href="${buildURL(page + 1)}" class="page-link next">»</a>`;
//     } else {
//       html += `<span class="page-link next disabled">»</span>`;
//     }
//
//     html += '</div>';
//
//     $('#loadMoreWrapper').html(html);
//   }
//
//   /* ---------------------------
//    * PAGINATION CLICK
//    * --------------------------- */
//   $(document).on('click', '.pagination a', function (e) {
//     e.preventDefault();
//
//     const url = $(this).attr('href');
//
//     window.history.pushState({}, '', url);
//
//     const pageMatch = url.match(/\/page\/(\d+)/);
//     const page = pageMatch ? parseInt(pageMatch[1]) : 1;
//
//     loadPosts(page);
//   });
//
//   /* ---------------------------
//    * BACK/FORWARD
//    * --------------------------- */
//   window.addEventListener('popstate', () => {
//     const state = getStateFromURL();
//
//     selectedCats = state.cats;
//     currentPage = state.page;
//
//     $('.category-checkbox').removeClass('selected');
//
//     selectedCats.forEach((slug) => {
//       $(`.category-checkbox[data-slug="${slug}"]`).addClass('selected');
//     });
//
//     renderPickedCategories();
//     loadPosts(currentPage);
//   });
//
//   /* ---------------------------
//    * INIT
//    * --------------------------- */
//   const state = getStateFromURL();
//
//   selectedCats = state.cats;
//   currentPage = state.page;
//
//   selectedCats.forEach((slug) => {
//     $(`.category-checkbox[data-slug="${slug}"]`).addClass('selected');
//   });
//
//   renderPickedCategories();
//   loadPosts(currentPage);
// });
/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  $('.contact-section__slider').slick('setPosition');
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});
// Hide header on scroll down, show on scroll up
(function () {
  const $header = $('.header');
  const $stickyPhone = $('.sticky-phone-desktop');

  if (!$header.length) return;

  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  const delta = 10;
  const showAfter = 60;

  function hideHeader() {
    $header.addClass('is-hidden');
    $header.removeClass('visible');
    document.body.classList.add('header--hidden');
    $stickyPhone.addClass('is-visible');
  }

  function showHeader() {
    $header.removeClass('is-hidden');
    $header.addClass('visible');
    document.body.classList.remove('header--hidden');
  }

  function onScroll() {
    const current = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(current - lastScroll) <= delta) {
      ticking = false;
      return;
    }

    const menuIsOpen =
      $('.top-bar').hasClass('is-active') ||
      $('.menu-icon').hasClass('is-active');

    if (menuIsOpen) {
      showHeader();
      lastScroll = current;
      ticking = false;
      return;
    }

    if (current > lastScroll && current > showAfter) {
      hideHeader();
    } else {
      showHeader();
    }

    lastScroll = Math.max(current, 0);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  /**
   * Create CSS variable for header height
   */
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
// document.addEventListener('DOMContentLoaded', function () {
//   const toggles = document.querySelectorAll('.submenu-toggle');
//
//   function updateParentsHeight(submenu) {
//     let parentSubmenu = submenu.parentElement.closest('.submenu');
//
//     while (parentSubmenu) {
//       parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + 'px';
//
//       parentSubmenu = parentSubmenu.parentElement.closest('.submenu');
//     }
//   }
//
//   toggles.forEach((toggle) => {
//     toggle.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//
//       const parent = this.closest('.has-dropdown');
//
//       // only direct child submenu
//       const submenu = [...parent.children].find((child) =>
//         child.classList?.contains('submenu')
//       );
//
//       const expanded = this.getAttribute('aria-expanded') === 'true';
//
//       this.setAttribute('aria-expanded', !expanded);
//
//       parent.classList.toggle('submenu-open');
//
//       if (!submenu) return;
//
//       if (expanded) {
//         submenu.style.maxHeight = null;
//
//         // update parent heights after close
//         requestAnimationFrame(() => {
//           updateParentsHeight(parent);
//         });
//       } else {
//         submenu.style.maxHeight = submenu.scrollHeight + 'px';
//
//         updateParentsHeight(submenu);
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.submenu-toggle');

  // Recalculate all parent submenu heights
  function updateParentsHeight(element) {
    let parentSubmenu = element.closest('.submenu');

    while (parentSubmenu) {
      // reset height first
      parentSubmenu.style.maxHeight = 'none';

      // apply updated height
      parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + 'px';

      parentSubmenu = parentSubmenu.parentElement?.closest('.submenu');
    }
  }

  // Close all nested submenus
  function closeNestedSubmenus(submenu) {
    const openedItems = submenu.querySelectorAll('.has-dropdown.submenu-open');

    openedItems.forEach((item) => {
      item.classList.remove('submenu-open');

      const toggle = item.querySelector(':scope > .submenu-toggle');

      const innerSubmenu = [...item.children].find((child) =>
        child.classList?.contains('submenu')
      );

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (innerSubmenu) {
        innerSubmenu.style.maxHeight = null;
      }
    });
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      this.classList.toggle('is-active');

      const parent = this.closest('.has-dropdown');

      if (!parent) return;

      // only DIRECT child submenu
      const submenu = [...parent.children].find((child) =>
        child.classList?.contains('submenu')
      );

      if (!submenu) return;

      const expanded = this.getAttribute('aria-expanded') === 'true';

      // CLOSE
      if (expanded) {
        this.setAttribute('aria-expanded', 'false');

        parent.classList.remove('submenu-open');

        submenu.style.maxHeight = null;

        // close all nested opened submenus
        closeNestedSubmenus(submenu);

        // update parents after DOM repaint
        requestAnimationFrame(() => {
          updateParentsHeight(parent);
        });
      }

      // OPEN
      else {
        this.setAttribute('aria-expanded', 'true');

        parent.classList.add('submenu-open');

        submenu.style.maxHeight = submenu.scrollHeight + 'px';

        updateParentsHeight(submenu);
      }
    });
  });
});

// Hide header on scroll down, show on scroll up
(function () {
  const $header = $('.header');
  const $stickyPhone = $('.sticky-phone-desktop');
  if (!$header.length) return;

  let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;
  const delta = 10;
  const showAfter = 60;

  function onScroll() {
    const current = window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(current - lastScroll) <= delta) {
      ticking = false;
      return;
    }

    // If mobile menu is open, keep header visible
    const menuIsOpen =
      $('.top-bar').hasClass('is-active') ||
      $('.menu-icon').hasClass('is-active');
    if (menuIsOpen) {
      if ($header.hasClass('is-hidden')) $header.removeClass('is-hidden');
      lastScroll = current <= 0 ? 0 : current;
      ticking = false;
      return;
    }

    if (current > lastScroll && current > showAfter) {
      // scrolled down
      if (!$header.hasClass('is-hidden')) {
        $header.addClass('is-hidden');
        $header.removeClass('visible');

        document.body.classList.add('header--hidden');
      }

      if ($stickyPhone.length && !$stickyPhone.hasClass('is-visible')) {
        $stickyPhone.addClass('is-visible');
      }
    } else if (
      current + window.innerHeight < document.body.scrollHeight ||
      current <= showAfter
    ) {
      // scrolled up or near top
      if ($header.hasClass('is-hidden')) {
        $header.removeClass('is-hidden');
        $header.addClass('visible');
        document.body.classList.remove('header--hidden');
      }

      // $stickyPhone.removeClass('is-visible');
    }

    lastScroll = current <= 0 ? 0 : current; // for Mobile or negative scrolling
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
})();

document.querySelectorAll('.js-video-trigger').forEach(function (wrapper) {
  wrapper.addEventListener('click', function () {
    const iframe = wrapper.querySelector('iframe');
    const video = wrapper.querySelector('video');

    // YouTube / Vimeo iframe
    if (iframe) {
      let src = iframe.getAttribute('src');

      if (!src.includes('autoplay=1')) {
        src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
        iframe.setAttribute('src', src);
      }
    }

    // HTML5 video
    if (video) {
      video.play();
      video.setAttribute('controls', true);
    }

    wrapper.classList.add('is-playing');
  });
});
